const Header = () => {
  return (
    <header className="">
      <div className="topbar">
        <div className="container-fluid">
          <div className="navbar-header">
            <div className="d-flex align-items-center gap-2">
              <div className="logo-box">
                <a href="" className="logo-dark">
                  <img src="/assets/images/logo-new.png" className="logo-lg" alt="logo dark" />
                </a>
              </div>
            </div>

            <div className="d-flex align-items-center gap-1">
              <div className="topbar-item d-none d-md-flex">
                <button type="button" className="topbar-button">
                  <i className="ri-settings-4-line fs-24"></i>
                </button>
              </div>
              <div className="dropdown topbar-item">
                <button type="button" className="topbar-button position-relative" id="page-header-notifications-dropdown">
                  <i className="ri-notification-3-line fs-24"></i>
                  <span className="position-absolute topbar-badge fs-10 translate-middle badge bg-danger rounded-pill">
                    3<span className="visually-hidden">unread messages</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
